import React from 'react';
import './index.css'
// import { Layout } from 'antd'
import ChatSider from './ChatSider'
import ChatContent from './ChatContent'
import Axios from 'axios'
import Empty from './images/empty.png'
import NettyClient from './sdk/sdk';
import { message } from 'antd';
import Header4 from '../../Header/Header4';
import Navigator from '../../Navigator'

export default class UserChat extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            onlineUserId: 9, // 在线用户Id
            messageData: [], // 会话列表信息
            friendData: [],  // 好友列表信息   
            chatmessageInfo: [], // 聊天记录信息 当前会话的聊天记录,
            showMessageId: -1,  // 当前会话列表中激活的id(无法区分公私聊)
            contactType: "",    // 弥补上面不足(区分公私聊)
            clusterName: "",  // 标记好友列表
            messageItemName: "",  // 会话名称
        }
        this.client = null;
        this.siderRefs = ""
        this.contentRefs = ""
    }

    componentDidMount() {
        // debugger
        const apiRoot = global.url.im;
        // 新建NettyClient客户端
        this.client = new NettyClient({ url: global.support.imServer });
        // 连接到imServer
        this.client.connect({ userId: this.state.onlineUserId, userType: "Servicer"});
        // 监听PUBLISH事件（群消息）
        this.client.on('PUBLISH', msg => {
            console.log('Received publish message: ', msg);
            if (this.state.showMessageId !== msg.receiver) {
                message.info(`群${msg.receiver}有消息`);

            }
        })

        // 监听SEND事件（私聊消息）
        this.client.on('SEND', msg => {
            console.log('Received send message: ', msg)
            if (this.state.showMessageId !== msg.receiver) {
                message.info(`好友${msg.sender}有消息`);
            }
        })

        // 获取会话列表    
        Axios.get(`${apiRoot}/contact/${this.state.onlineUserId}`)
            .then(res => {
                this.setState({
                    messageData: res.data.payload
                })
            })


        // 获取好友列表
        Axios.get(`${apiRoot}/friend/${this.state.onlineUserId}`)
            .then(res => {
                if (res.data.payload !== null) {
                    for (let i = 0; i < res.data.payload.length; i++) {
                        res.data.payload[i].contactType = "private"
                    }
                    this.setState({
                        friendData: res.data.payload
                    })
                }
            })

        // 获取用户登录信息
        // const sysRoot = global.url.sys;
        // Axios.get(`${sysRoot}/sys/user/${this.state.onlineUserId}`)
        //     .then(res => {

        //         this.setState({
        //             onlineUser: res.data.payload
        //         })
        //     })


    }

    // 获取子组件ChatSider的state
    getSiderMsg = (result, msg) => {
        // 很奇怪这里的result就是子组件那bind的第一个参数this，msg是第二个参数
        // console.log(result.state)
        const apiRoot = global.url.im;
        this.setState({
            showMessageId: result.state.activeMessageId, // 当前激活的会话列表id
            contactType: result.state.contactType,      // 用于标记会话列表中是公聊还是私聊
        }, () => {
            const { showMessageId, contactType, onlineUserId, messageData } = this.state
            console.log(showMessageId, contactType)

            if (contactType === "private") {
                // 处理点击好友获取聊天记录
                let data = {
                    "current": 1,
                    "size": 10,
                    "orders": [
                        { "column": "create_time", "asc": false }
                    ]
                }
                Axios.post(`${apiRoot}/message/private/page?senderId=${onlineUserId}&receiverId=${showMessageId}`, data)
                    .then(res => {

                        this.setState({
                            chatmessageInfo: res.data.records.reverse()
                        })
                    })

            } else if (contactType === "public") {
                // 处理点击群组获取聊天记录
                let data = {
                    "current": 1,
                    "size": 10,
                    "orders": [
                        { "column": "create_time", "asc": false }
                    ]
                }
                Axios.post(`${apiRoot}/message/public/page?groupId=${showMessageId}`, data)
                    .then(res => {
                        this.setState({
                            chatmessageInfo: res.data.records.reverse()
                        })
                    })

            }

            // 获取当前会话信息
            messageData.some((item) => {
                if (item.contactType === contactType && item.receiverId === showMessageId) {
                    this.setState({
                        messageItem: item
                    }, () => {
                        return true
                    })
                }
            })

            
        })
    }

    // 更新聊天信息 
    handleUpdateChatMessageInfo = (updateData, contactType) => {

        const { chatmessageInfo } = this.state

        if (contactType === "public") {
            chatmessageInfo.push(updateData)
            this.setState({
                chatmessageInfo: chatmessageInfo
            })
        } else if (contactType === "private") {
            chatmessageInfo.push(updateData)
            this.setState({
                chatmessageInfo: chatmessageInfo,
            })
        } else {
            return
        }


    }

    render() {

        const { messageData, friendData, messageItem, chatmessageInfo, clusterName, contactType, onlineUserId, showMessageId } = this.state
        return (
            <>
            <Header4 />
                {/* <Layout className="chat-all">
                    <Layout.Sider className="chat-sider">
                        2222
               </Layout.Sider>
                    <Layout.Content>
                        111111
               </Layout.Content>
                </Layout> */}
                <div style={{ width: "100%", height: "100%", background: "#e4e9f1" }}>
                    <div className="mychat-all">
                        <div style={{ flex: "350px", height: "888px", display: "flex" }}>
                            <div style={{ width: "350px", height: "100%", marginRight: "10px" }}>
                                <ChatSider
                                    // ref={el => this.siderRefs = el}
                                    parent={this}
                                    messageData={messageData}
                                    friendData={friendData}
                                    onlineUserId={onlineUserId}
                                />
                            </div>
                            <div className="mychat-content">
                                {
                                    // 判断当权会话的消息是否已经setState
                                    messageItem === undefined
                                        ?
                                        <div style={{ overflow: "hidden", background: "#f5f7fa", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div style={{ width: "250px", height: "274px", display: "flex", flexDirection: "column" }}>
                                                <div style={{ background: `url(${Empty})`, width: "250px", height: "250px" }}>

                                                </div>
                                                <div style={{ width: "250px", height: "24px", fontSize: "18px", color: "#d3d3d3", textAlign: "center" }}>
                                                    未选择消息
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <ChatContent
                                            parent={this}
                                            friendData={friendData}
                                            clusterName={clusterName}
                                            messageData={messageData}
                                            messageItem={messageItem}
                                            contactType={contactType}
                                            chatmessageInfo={chatmessageInfo}
                                            onlineUserId={onlineUserId}
                                            showMessageId={showMessageId}
                                            client={this.client}
                                            updateChatMessageInfo={this.handleUpdateChatMessageInfo}
                                        />
                                }

                            </div>
                        </div>
                    </div>
                </div>
                <Navigator />
            </>
        )
    }
}